// components/QueryHistory.tsx
import { useState, useEffect } from 'react';
import { MdDelete } from "react-icons/md";

export default function QueryHistory() {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchHistory();
    }, []);

    const fetchHistory = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/query-history`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('text2sql_authToken')}`
                }
            });
            if (response.status === 401) {
                localStorage.removeItem('text2sql_authToken');
                localStorage.removeItem('text2sql_user');
                window.location.href = (process.env.REACT_APP_BASE_PATH || "") + "/login";
                return;
            }
            const data = await response.json();
            setHistory(data.history);
        } catch (error) {
            console.error('Error fetching history:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteQuery = async (queryId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this query?");

        if (!confirmDelete) return; // ❌ User cancelled

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/query-history/${queryId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('text2sql_authToken')}`
                }
            });
            if (response.status === 401) {
                localStorage.removeItem('text2sql_authToken');
                localStorage.removeItem('text2sql_user');
                window.location.href = (process.env.REACT_APP_BASE_PATH || "") + "/login";
                return;
            }
        } catch (error) {
            console.error('Error deleting query history:', error);
        } finally {
            fetchHistory();
        }
    };

    if (loading) return <div>Loading history...</div>;

    return (
        <div className="max-w-4xl mx-auto p-8">
            <h2 className="text-2xl font-bold mb-6">Query History</h2>
            <div className="space-y-4">
                {
                    history?.length > 0 ?

                        history?.map((item) => (
                            <div key={item.id} className="bg-white p-4 rounded-lg shadow">
                                <div className="flex justify-between items-start mb-2">
                                    <span className="text-sm text-gray-500">{item.query_type === "sql2text" ? "SQL to Text" : "Text to SQL"}</span>
                                    <div className='flex items-center'>
                                        <span className="text-xs text-gray-400">
                                            {new Date(item.created_at).toLocaleString()}
                                        </span>
                                        <div className='' onClick={() => handleDeleteQuery(item.id)}>
                                            <MdDelete className="inline ml-4 cursor-pointer text-red-500" title="Delete" />
                                        </div>
                                    </div>
                                </div>

                                {item.query_type === "sql2text" && (
                                    <div>
                                        <div className="mb-2">
                                            <strong>Question:</strong> {item.sql_query}
                                        </div>
                                        <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
                                            {item.explanation}
                                        </pre>
                                    </div>
                                )}
                                {item.query_type === "text2sql" && item.natural_language && (
                                    <div>
                                        <div className="mb-2">
                                            <strong>Question:</strong> {item.natural_language}
                                        </div>
                                        <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
                                            {item.sql_query}
                                        </pre>
                                    </div>
                                )}
                            </div>
                        ))
                        : "No query history found."
                }
            </div>
        </div>
    );
}